import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { Profile } from './Profile/index.jsx'
import { PageLayout } from '../components/layout'
import { IconButton, Icon } from '../components/ui'
import { UserContext } from '../contexts'

import './Profile/profile-dark.scss'

/**
 * /profile page shell.
 *
 * Deliberately mirrors the `action === "create"` branch of `views/UsersPage.jsx`
 * (/users/create): the same `PageLayout` (`.rc-page`) → `.users-shell` →
 * `.users-create-wrap` chain, and the same `.users-dark.users-dark--create`
 * scope, so the dark surfaces / dark inputs / purple submit in
 * `styles/_users-dark-theme.scss` apply here without being re-declared.
 * `profile-dark` only carries what is genuinely Profile-only (the hero card,
 * verification cards, alerts).
 *
 * Fontaine M56A: the back control is the shared `IconButton` + `Icon`
 * primitives (bare `<button>← Back</button>` text link retired here only —
 * `/users/create` keeps its own, out of scope). Same class, same
 * `history.goBack()`, so `_users-dark-theme.scss`'s `.users-create-wrap__back`
 * positioning still applies; only the control's own paint comes from IconButton.
 *
 * `authentication` comes from UserContext rather than a layout prop: RCAdminLayout
 * passes only `user` to its content (DefaultLayout used to spread the whole route
 * context), and Profile needs `authentication.update()` after an avatar / ID upload.
 * `Route.jsx` builds that context as `authentication: userContext`, so this is the
 * same object, just read directly.
 */
const ProfilePage = props => {
    const history = useHistory();
    const userContext = useContext(UserContext);

    return (
        <PageLayout className="users-dark users-dark--create profile-dark">
            <div className="users-shell">
                <div className="users-create-wrap">
                    <div className="users-create-wrap__header">
                        <IconButton
                            variant="ghost"
                            label="Back"
                            className="users-create-wrap__back"
                            onClick={() => history.goBack()}
                        >
                            <Icon name="ArrowLeft" size="md" />
                        </IconButton>
                        <h1 className="users-create-wrap__title">My Profile</h1>
                    </div>

                    <Profile
                        {...props}
                        user={userContext.user}
                        authentication={userContext}
                    />
                </div>
            </div>
        </PageLayout>
    )
};

export default ProfilePage;
